import type { Question } from '@mentimeter/legacy-series-types/question';
import type { EditorInteractiveContent } from '../../compatibility-overrides/editor-types';
import { questionActiveToResponseMode } from '../converters/question/question-active-to-response-mode';
import {
  RESPONSE_POLICY_NO_RESTRICTION,
  RESPONSE_POLICY_SINGLE_RESPONSE_SINGLE_CHOICE,
} from '../../constants';

export const getWordcloudInteractiveContent = (question: Question) => {
  const content: Partial<EditorInteractiveContent> = {
    maxEntries: null,
    scoring: null,
    countdown: question.countdown_to_vote,
    interactiveContentId: `${question.id}-interactive`,
    title: question.question,
    description: question.question_description,
    image: null,
    correctArea: null,
    voteSettings: null,
    responsePointQuota: null,
    responseRange: null,
    choices: [],
    responseMode: questionActiveToResponseMode(question.active),
    responsePolicy: getResponsePolicy(question),
  };

  return content;
};

export const getResponsePolicy = (question: Question) => {
  if (question.multiple_votes) {
    return RESPONSE_POLICY_NO_RESTRICTION;
  }

  return RESPONSE_POLICY_SINGLE_RESPONSE_SINGLE_CHOICE;
};
